import "esbuild-css-modules-plugin-ns-css:src/js/pages/serviceLocationStep/serviceLocationStep.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/pages/serviceLocationStep/serviceLocationStep.module.css:injector.js";
export default new Proxy({
  "mobileH2": "serviceLocationStep-module__mobileH2_k964bW__1100",
  "pageContainer": "serviceLocationStep-module__pageContainer_k964bW__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      